export default {
  namespaced: true,
  state: {
    modal: {
      visible: false
    },
    header: {
      visible: true,
      title: null,
      isGobackEvent: false // 임시
    },
    footer: {
      visible: true
    },
    captureMode: false,
  },
  mutations: {
    headerVisible(state, flag) {
      state.header.visible = flag
    },
    footerVisible(state, flag) {
      state.footer.visible = flag
    },
    headerTitle(state, title) {
      state.header.title = title
    },
    headerGobackHasEvent(state, flag) {
      state.header.isGobackEvent = flag
    },
    modalVisible(state, flag) {
      state.modal.visible = flag
    },
    setCaptureMode(state, flag) {
      state.captureMode = flag
    },
  },
  actions: {
    headerVisible({ commit }, flag) {
      commit('headerVisible', flag)
    },
    footerVisible({ commit }, flag) {
      commit('footerVisible', flag)
    },
    headerTitle({ commit }, title) {
      commit('headerTitle', title)
    },
    headerGobackHasEvent({ commit }, flag) {
      commit('headerGobackHasEvent', flag)
    },
    modalVisible({ commit }, flag) {
      commit('modalVisible', flag)
    }
  }
}
